import { Counterparty } from 'entities/counterparties/model'
import React, { FC } from 'react'
import { TabsWrapper, WrapperAvatar } from 'features/Clients/ui/style'
import { Tab, Tabs } from 'shared/components/Tabs'
import { UpdateAvatarForm } from 'features/Clients/ui/components/UpdateAvatarForm'
import { StyledLine } from 'shared/styles/GlobalStyle'
import { WrapperFormRow } from 'shared/components/WrapperFormRow'
import { FormDataGeneralCompany } from 'features/Clients/model/formData'
import { FormikInput } from 'shared/components/FormikInput'
import { Certificates } from 'entities/certificates'
import { OrdersTable } from 'features/Clients/ui/ordersTable'
import { FieldArray, Form } from 'formik'
import { useParams } from 'react-router-dom'
import { useParseCounterparty } from 'features/Clients/model/useParseCounterparty'
import { ContactForm } from 'features/Clients/ui/components/ContactForm'
import { ContactDTO } from 'entities/counterparties/model/dtoTypes'

interface CompanyProfileFormProps {
    isEditable: boolean
    counterparty?: Counterparty
    contacts: ContactDTO[]
    setPhoto: (file: File | null) => void
    setDefaultContacts: (value: ContactDTO[]) => void
}

export const CompanyProfileForm: FC<CompanyProfileFormProps> = ({
    contacts,
    isEditable,
    counterparty,
    setPhoto,
    setDefaultContacts,
}) => {
    const { id } = useParams()

    const { isCompany, counterpartyProfilePhoto, counterpartyName } =
        useParseCounterparty(counterparty)

    return (
        <Form>
            <TabsWrapper>
                <Tabs>
                    <Tab label='Профиль'>
                        <WrapperAvatar>
                            <UpdateAvatarForm
                                isEditable={isEditable}
                                isCompany={isCompany}
                                photo={counterpartyProfilePhoto}
                                name={counterpartyName}
                                updatePhoto={setPhoto}
                            />
                        </WrapperAvatar>
                        <StyledLine margin='20px 0' />
                        <WrapperFormRow
                            title='Общие данные'
                            formData={FormDataGeneralCompany.map(row =>
                                row.map(item => ({
                                    ...item,
                                    disabled:
                                        item.name === 'created_at'
                                            ? true
                                            : !isEditable,
                                    placeholder: isEditable
                                        ? item.placeholder
                                        : '',
                                })),
                            )}
                        >
                            {counterparty && counterparty.isBlackList && (
                                <div className='row'>
                                    <FormikInput
                                        name='comment'
                                        label='Комментарий'
                                        placeholder={
                                            isEditable ? 'Комментарий' : ''
                                        }
                                        className='inputForm'
                                        disabled={!isEditable}
                                        $afterIcon='clearInput'
                                    />
                                </div>
                            )}
                        </WrapperFormRow>

                        <FieldArray name='contacts'>
                            {({ push, remove }) => (
                                <ContactForm
                                    setDefaultContacts={setDefaultContacts}
                                    contacts={contacts}
                                    isEditable={isEditable}
                                    currentCounterpartyId={
                                        counterparty?.id ?? null
                                    }
                                    remove={remove}
                                    addContact={() =>
                                        push({
                                            first_name: '',
                                            surname: '',
                                            patronymic: '',
                                            phone: '',
                                            email: '',
                                        })
                                    }
                                />
                            )}
                        </FieldArray>
                        <Certificates counterparty_id={id} />
                    </Tab>
                    <Tab label='История заказов'>
                        {id && <OrdersTable id={id} />}
                    </Tab>
                </Tabs>
            </TabsWrapper>
        </Form>
    )
}
